import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getAppExperiences} from "../services/UserTypeService";
import {useLogout} from "./useLogout";

export function useAppExperiences({enabled = true} = {}) {
    const [appExperiences, setAppExperiences] = useState([]);

    const logout = useLogout();
    const {data, isError, error} = useQuery({
        queryKey: ["appExperiences"],
        queryFn: getAppExperiences,
        enabled: enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            setAppExperiences(data);
        }
    }, [data]);

    return [appExperiences];
}
